<template>
  <div :class="`as-standing as-parent-standing as-parent-standing-${siteName}`">
    <div class="as-standing__league-info">
      <div class="as-league_title">
        <SkeletonLoader width="30px" height="30px" mode="circle" :line="1" />
        <SkeletonLoader width="130px" height="20px" :line="1" />
      </div>
      <SkeletonLoader width="100px" height="20px" :line="1" />
    </div>

    <div class="as-standing__top">
      <div class="as-nav-tabs-btn">
        <SkeletonLoader width="80px" height="30px" :line="1" />
        <SkeletonLoader width="80px" height="30px" :line="1" />
        <SkeletonLoader width="80px" height="30px" :line="1" />
      </div>
    </div>
    <div class="as-show-full as-scrolling as-scrolling__have-tab as-scrolling__result-popup">
      <div class="as-standing__table">
        <div class="as-standing__table-row as-standing__table-row-head">
          <div v-for="colIndex in 11" :key="colIndex" class="as-standing__table-column" type="button">
            <SkeletonLoader :width="colIndex === 2 ? '100px' : colIndex > 2 ? '40px' : '30px'" height="20px" :line="1" />
          </div>
        </div>

        <div v-for="rowIndex in 15" :key="rowIndex" class="as-standing__table-row">
          <div v-for="colIndex in 11" :key="colIndex" class="as-standing__table-column">
            <SkeletonLoader :width="colIndex === 2 ? '100px' : colIndex > 2 ? '40px' : '30px'" height="20px" :line="1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";
const commonStore = usecommonStore();

interface IProps {
}

const props = withDefaults(defineProps<IProps>(), {});

const siteName = computed(() => commonStore.getSiteName);
</script>
